<template>
  <div class="filter-item btn btn-sm btn-outline-secondary" @click="handleClick" :class="{ disabled: disabled }  ">
    <div class="filter-content">
      <div class="filter-label">
        <component  v-if="filter?.icon"
                    :is="filter?.icon"
                    :size="14"
                    class="filter-icon" />
        <span class="filter-text">{{ filterText }}</span>
      </div>
      <div class="filter-actions">
        <!-- <X :size="14" class="filter-icon" @click.stop="handleReset" /> -->
        <ChevronDown :size="14" class="filter-chevron opacity-50" />
      </div>
    </div>
  </div>
</template>

<script>
import { X, ChevronDown, Circle, Filter, Globe,
  RefreshCw, MapPin, Layers, Funnel,
  SquareDashed, Square, Blocks, Building2,
  PackageOpen,Package } from 'lucide-vue-next';
import { countCheckedLeaves } from '@/utils/treeHelpers';

export default {
  name: 'FilterItem',

  emits: ['click', 'reset'],

  props: {
    disabled: { type: Boolean, default: false },
    filter: { type: Object, required: true },
    rank:   { type: Number, required: true }
  },

  components: {
    X,
    ChevronDown
  },

  computed: {
    filterText() {
      const count = this.filter ? countCheckedLeaves(this.filter.selection) : 0;
      if (count === 0)
        return this.filter ? this.filter.label : '';
      else
        return this.filter ? this.filter.label + `(${count})` : '';
    }
  },

  methods: {
    handleClick() {
      this.$emit('click', this.filter);
    },

    handleReset() {
      this.$emit('reset', this.rank);
    }
  }
}
</script>

<style lang="scss" scoped>

.filter-item {
  border: 4px solid var(--custom-white-20);
  background: var(--custom-black-05);
  position: relative;
  border-radius: 2px;
  height: 2.25rem;
  min-width: 7.5rem;
  padding: 4px 8px;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: var(--custom-black-10);
    border-color: var(--custom-black-20);
  }

  [data-bs-theme="dark"] & {
    background: var(--custom-white-10);
    &:hover {
      background: var(--custom-white-20);
      border-color: var(--custom-white-20);
    }
  }
}

.filter-content {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0px;
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 10;
}

.filter-label {
  display: flex;
  align-items: center;
  gap: 4px;
  overflow: hidden;
}

.filter-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.filter-icon {
  flex-shrink: 0;
}

.filter-chevron {
  flex-shrink: 0;
}

.filter-text {
  font-size: var(--font-12);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
